import { FacilityType } from './questionInteractStates'

export const hasFacility = (facilityName: FacilityType, interestedFacility: string[]): boolean =>
  interestedFacility.includes(facilityName)
